import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = ["bar"]
    connect() {
        this.content = document.querySelector('[data-single-content]');

        this._onScroll = this.onScroll.bind(this)
        this._onResize = this.onResize.bind(this)

        window.addEventListener("scroll", this._onScroll, { passive: true });
        window.addEventListener("resize", this._onResize);

        this.onResize();
    }
    disconnect() {
        window.removeEventListener("scroll", this._onScroll);
        window.removeEventListener("resize", this._onResize);
    }

    onResize() {
        this.recalc()
        this.onScroll()

        if(!window.matchMedia('(max-width:999px').matches) {
            if(this.element.getBoundingClientRect().height + 60 > window.innerHeight) {
                this.element.setAttribute('data-position', "static");
            } else {
                this.element.setAttribute('data-position', "sticky");
            }
        } else {
            this.element.setAttribute('data-position', "fixed");
        }

    }
    recalc() {
        const el = this.content;
        const rect = el.getBoundingClientRect()
        const scrollTop = window.scrollY || document.documentElement.scrollTop
        const vh = window.innerHeight || document.documentElement.clientHeight

        // positions absolues dans la page
        const top = rect.top + scrollTop
        const bottom = top + el.offsetHeight

        // On commence à 0% quand le TOP du contenu touche le TOP du viewport (y = top)
        // On finit à 100% quand le BOTTOM du contenu touche le BOTTOM du viewport (y = bottom - vh)
        this.startY = top
        this.endY   = Math.max(top, bottom - vh)

        this.range  = Math.max(1, this.endY - this.startY)
    }

    onScroll() {
        const y = window.scrollY || document.documentElement.scrollTop

        // 0% au moment où le scroll atteint le top du contenu, 100% au moment où il atteint le bas du contenu
        const pct = ((y - this.startY) / this.range) * 100
        const clamped = Math.min(100, Math.max(0, pct))

        this.barTarget.style.width = `${clamped}%`
    }

    goToCtn(event) {
        event.preventDefault();

        const gap = 140;
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            const top = targetElement.getBoundingClientRect().top + window.scrollY - gap;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    }
}